import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export default function ConfirmDialog({
  open,
  title,
  content,
  deleteModal,
  onClose,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="default" variant="contained" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          color={deleteModal ? 'error' : 'success'}
          variant="contained"
          onClick={() => onConfirm()}
        >
          {deleteModal ? 'Delete' : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
